/* This renders the final card crediting all the people who 
   worked on this

   Hassaan Ali Wattoo 
*/ 

import React from 'react';

class CreditsCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            staff: [
                {'name': "Maya Goldman", 'role': "Editor In Chief"},
                {'name': "Max Marcovitch", 'role': "Managing Sports Editor"},
                {'name': "Ethan Sears", 'role': "Managing Sports Editor"},
                {'name': "Casey Tin", 'role': "Managing Online Editor"},
                {'name': "Hassaan Ali Wattoo", 'role': "Managing Online Editor"},
                {'name': "Alice Shih", 'role': "Product Designer"},
                {'name': "Jack Silberman", 'role': "Managing Design Editor"},
                {'name': "Alexis Rankin", 'role': "Managing Photo Editor"},
                {'name': "Alec Cohen", 'role': "Managing Photo Editor"},
            ]
        }
    }

    

    render() {
        return (
            <div className={`row donate-card credits-card`}>
                <div className={`donate-text six columns`}>
                    <div className="donate-heading">
                    PRODUCED BY THE STAFF OF THE MICHIGAN DAILY.
                    </div>
                </div>
                <div className={`donate-text donate-buttons credits six columns`}>
                {this.state.staff.map((person) => {
                    return (
                        <div className="credit">
                            <div> <strong>{person.name}</strong></div>
                            <div>{person.role}</div>
                        </div>
                    )
                })}
                </div>
            </div>      
        );
    }
        
    
}

export default CreditsCard;